import {Instagram, Linkedin} from "lucide-react";

export default function Footer() {
    return (
        <footer className="text-center py-4 border-t border-gray-300">
            <div className="mb-4">
                <span className="mb-1">Contact Us</span>
                <div className="flex justify-center space-x-4">
                    <a className="flex-center gap-1 hover:text-blue-600 transition-200"
                       href="https://www.linkedin.com/company/hack-the-diff/?viewAsMember=true" target="_blank"
                       rel="noopener noreferrer">
                        <Linkedin className="w-5 h-5"/>
                        LinkedIn
                    </a>
                    <a className="flex-center gap-1 hover:text-primary transition-200"
                       href="https://www.instagram.com/hackthediff" target="_blank" rel="noopener noreferrer">
                        <Instagram className="w-5 h-5"/>
                        Instagram
                    </a>
                </div>
            </div>
            <div className="flex-center flex-col md:flex-row gap-2 md:gap-4">
                <p>&copy; {new Date().getFullYear()} Hack The Diff. All rights reserved.&nbsp;</p>
                <div className="flex-center gap-2 md:gap-4">
                    <a href="/privacy-policy" className="transition-200 text-blue-600 hover:text-blue-400">
                        Privacy Policy
                    </a>
                    <a href="/terms-of-service" className="transition-200 text-blue-600 hover:text-blue-400">
                        Terms of Service
                    </a>
                </div>
            </div>
        </footer>
    )
}
